var map = {
	"./New_logo.png": 651,
	"./apoteka-logo.png": 652,
	"./aside-basket.png": 653,
	"./ava.png": 482,
	"./banner-slider-desctop.png": 654,
	"./banner-slider-mobile.png": 655,
	"./basket-arrow.png": 656,
	"./basket-cart--desktop.png": 215,
	"./basket.png": 657,
	"./bonus/DOS.png": 183,
	"./bonus/Dos-expanded.png": 345,
	"./bonus/coins.png": 346,
	"./bonus/coins_checkout.png": 658,
	"./breadcrumbs-arrow.png": 659,
	"./btn-x.png": 660,
	"./burger-close.png": 661,
	"./burger-search.png": 662,
	"./cards/mastercard.png": 472,
	"./cards/mir.png": 473,
	"./cards/secure.png": 474,
	"./cards/visa.png": 475,
	"./cat-arrow.png": 663,
	"./cat-arrow2.png": 664,
	"./delivery-icon.png": 665,
	"./delivery.png": 666,
	"./edit-ava.png": 667,
	"./edit.png": 668,
	"./error-basket.png": 669,
	"./fire-old.png": 670,
	"./fire.png": 671,
	"./form-error.png": 672,
	"./form-success-curcle.png": 673,
	"./form-success.png": 674,
	"./input-check.png": 675,
	"./input-error.png": 676,
	"./loader.png": 494,
	"./location.png": 677,
	"./loop.png": 678,
	"./loopblack.png": 679,
	"./mailing.png": 495,
	"./map-location.png": 680,
	"./mastercard-logo.png": 347,
	"./mastercard-sm.png": 681,
	"./mastercard.png": 682,
	"./method1.png": 683,
	"./method2.png": 684,
	"./method3.png": 685,
	"./modal-x.png": 477,
	"./next-bl.png": 686,
	"./next.png": 687,
	"./offer1.png": 688,
	"./offer2.png": 689,
	"./offer3.png": 690,
	"./offer4.png": 691,
	"./offer5.png": 692,
	"./open.png": 693,
	"./payment/pci.png": 486,
	"./payment/tls.png": 487,
	"./pci.png": 694,
	"./phone.png": 695,
	"./pm1.png": 696,
	"./pm2.png": 697,
	"./pm3.png": 698,
	"./prev-bl.png": 699,
	"./prev.png": 700,
	"./pros1.png": 701,
	"./pros2.png": 702,
	"./pros3.png": 703,
	"./pros4.png": 704,
	"./qiwi.png": 705,
	"./quote.png": 706,
	"./rckf.png": 707,
	"./rckf_hover.png": 708,
	"./reply-btn.png": 709,
	"./search-clear.png": 710,
	"./sign-facebook.png": 496,
	"./sign-in-facebook.png": 711,
	"./sign-in-twitter.png": 712,
	"./sign-in-vk.png": 713,
	"./sign-in.png": 714,
	"./sign-twitter.png": 497,
	"./sign-vk.png": 498,
	"./stars.png": 715,
	"./trash-return.png": 499,
	"./trash.png": 500,
	"./visa-sm.png": 348,
	"./visa.png": 716,
	"./white-arrow.png": 717,
	"./white-check.png": 718,
	"./yandex-taxi.png": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;